import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';

@Component({
  selector: 'app-reward-created-modal',
  templateUrl: './reward-created-modal.component.html',
  styleUrls: ['./reward-created-modal.component.scss'],
})
/**
 * Component for displaying a modal when a reward is created.
 */
export class RewardCreatedModalComponent implements OnInit {
  labels = {
    added: 'reward-added-successfully',
    canCheck: 'reward-can-check',
    canEdit: 'reward-edit-details',
    goToProducts: 'go-to-products-panel',
    goToRewards: 'go-to-rewards-list',
    rewardCreated: 'reward-created',
  };

  /**
   * Initializes the RewardCreatedModalComponent.
   */
  constructor(
    private dialogRef: MatDialogRef<RewardCreatedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private translationService: TranslationService,
    private router: Router
  ) {}

  /**
   * OnInit
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
  }

  /**
   * Closes the modal and redirects to rewards list.
   */
  goToRewardsList() {
    this.dialogRef.close(MatDialogResponse.SUCCESS);
  }

  /**
   * Closes the modal and redirects to control panel.
   */
  goToProductsPanel() {
    this.dialogRef.close(MatDialogResponse.FAIL);
  }
}
